<template lang="pug">
v-dialog(
  :value='value.opened'
  transition='slide-x-reverse-transition'
  hide-overlay
  fullscreen
  persistent
  lazy
)
  v-card
    v-toolbar(color='primary' class='toolbar' dark flat prominent)
      v-btn(icon @click.native='close')
        v-icon close
      v-toolbar-title Сортировка
    div(class='app-workspace')
      div(class='sort-wrap')
        //- Сортировка внутри группы
        template(v-if='value.groupBy')
          div(v-for="(group, name) in items")
            div(class='title mb-3') {{ name }}
            div(v-sortable="{handler: '.handler', callback: onSorted}" class="wrap-all")
              div(
                v-for="item in group"
                :data-list-id="item[value.itemValue]"
                :key="item[value.itemValue]"
              )
                v-card(class='mt-2 card' flat)
                  div(class="item-inner")
                    div(class="item-row")
                      div(class="handler mr-3")
                        v-icon(color='black') menu
                      div(v-if='value.renderFn')
                        div(v-html='value.renderFn(item)')
                      div(v-else class="item-name")
                        div {{ item[value.itemText] }}
            div(class='mt-5')
        //- Сортировка без уровня вложенности
        template(v-else)
          div(v-sortable="{handler: '.handler', callback: onSorted}" class="wrap-all")
            div(
              v-for="item in items"
              :data-list-id="item[value.itemValue]"
              :key="item[value.itemValue]"
            )
              v-card(class='mt-2 card' flat)
                div(class="item-inner")
                  div(class="item-row")
                    div(class="handler mr-3")
                      v-icon(color='black') menu
                    div(class="item-name")
                      div(v-if='value.renderFn')
                        div(v-html='value.renderFn(item)')
                      div(v-else class="item-name")
                        div {{ item[value.itemText] }}
</template>

<script>
import http from '@/http'
import { groupBy } from 'lodash'

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    collection: {
      type: Array,
      required: false
    }
  },

  data: () => ({
    items: []
  }),

  async mounted() {
    let items = []

    if (this.value.resource) {
      // TODO: здесь мб с пагинацией и без,
      // поэтому data.data или data
      const { params = {}, resource } = this.value
      if (!params.sortBy) {
        params.sortBy = 'sort_number'
        params.descending = false
      }
      const { data } = await http.get(resource, { params })
      items = data.data ? data.data : data.list ? data.list : data

      if (this.value.groupBy) {
        this.items = groupBy(
          items.filter(v => v[this.value.groupBy]),
          this.value.groupBy
        )
        return
      }
    } else {
      items = this.collection
    }

    this.items = items
  },

  methods: {
    close() {
      this.$emit('input', {
        ...this.value,
        opened: false
      })
    },

    async onSorted({ target }) {
      const ids = [...target.childNodes].map(n => n.dataset.listId)
      if (this.value.resource) {
        try {
          await http.post(`${this.value.resource}/sort-ref`, { sort_ids: ids })
          this.$emit('sort-success', ids)
        } catch (e) {
          this.$root.showSnack('Ошибка сортировки')
          this.$emit('sort-error', e)
        }
      } else {
        this.$emit('sort-request', ids)
      }
    }
  },

  watch: {
    collection(val) {
      if (val) {
        this.items = val
      }
    }
  }
}
</script>

<style scoped>
.app-workspace {
  top: 64px;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
  overflow-y: auto;
  padding: 24px;
}
.toolbar {
  z-index: 10;
}
.item-row {
  display: flex;
  align-items: center;
}
.item-name {
  flex: 1;
}
.handler {
  cursor: move;
  color: black;
}
.item-inner {
  padding: 12px;
}
.card {
  background: #f6f5f3 !important;
  border: solid 1px #ccc !important;
}
.sort-wrap {
  max-width: 720px;
  margin: auto;
}
</style>
